import Handlebars from 'lib/handlebars.runtime-v2.0.0';
import { accounting } from 'lib/accounting';

export default Handlebars.registerHelper('formatMoney', function formatMoney(num) {
  return accounting.formatMoney(num);
});
